/**
 * Project-scoped marketplace URLs — keep deploy CTAs aligned with the
 * surface the user is on (apps list/detail → apps catalog; everything
 * else in a project → workflow catalog).
 */

export function projectWorkflowMarketplacePath(projectId) {
  return `/projects/${projectId}/marketplace/agents`;
}

export function projectAppsMarketplacePath(projectId) {
  return `/projects/${projectId}/marketplace/apps`;
}

/** Resolve project id from the URL when useParams() is empty. */
export function projectIdFromPathname(pathname) {
  const m = (pathname || '').match(/^\/projects\/([^/]+)/);
  return m ? m[1] : null;
}

/** True on /projects/:id/apps, /projects/:id/apps/:instanceId, or apps marketplace. */
export function isProjectAppsPath(pathname) {
  const path = pathname || '';
  return /^\/projects\/[^/]+\/apps(?:\/|$)/.test(path)
    || /^\/projects\/[^/]+\/marketplace\/apps(?:\/|$)/.test(path);
}

/** Pick workflow vs apps marketplace from the current pathname. */
export function projectMarketplacePathForLocation(projectId, pathname) {
  const path = pathname || '';
  const pid = projectId || projectIdFromPathname(path);

  if (!pid) {
    return isProjectAppsPath(path) ? '/marketplace/apps' : '/marketplace';
  }
  if (isProjectAppsPath(path)) {
    return projectAppsMarketplacePath(pid);
  }
  // Pipelines list, pipeline detail (/pipelines/:type), run tabs,
  // workflow marketplace, test runs, settings, etc.
  return projectWorkflowMarketplacePath(pid);
}
